import React from 'react'
import { useSelector } from 'react-redux'
import Loader from '../components/common/Loader'
import { Outlet } from 'react-router-dom'
import Sidebar from '../components/core/Dashboard/Sidebar'

const Dashboard = () => {

  const { loading: authLoading } = useSelector((state) => state.auth);
  const { loading: profileLoading } = useSelector((state) => state.profile);

  if (profileLoading || authLoading) {
    return (
      <Loader />
    )
  }

  return (
    <div className='mt-14'>
      <div className='relative  flex min-h-[calc(100vh-3.5rem)]'>
        <Sidebar />
        <div className='h-[calc(100vh-3.5rem)] overflow-auto flex-1 md:ml-[5rem]'>
          <div className='mx-auto w-11/12 max-w-[1000px] py-10'>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard